import * as React from 'react';

import { getBrandWelcome } from '@utils/get-brand-welcome.tsx';

import { useMutationPassOnboarding } from '@hooks/api/user/use-mutation-pass-onboarding';

import * as Styled from './welcome.styled.ts';

const Welcome = () => {
	const [page, setPage] = React.useState(1);
	const { mutate: markOnboardingPassed } = useMutationPassOnboarding(true);

	const welcomeFlow = getBrandWelcome();

	const nextClickHandler = () => {
		setPage(prev => prev + 1);

		// Mark onboarding as passed on the last page
		if (page === welcomeFlow.totalPages) {
			markOnboardingPassed();
		}
	};

	const prevClickHandler = () => {
		setPage(prev => prev - 1);
	};

	// Get current step configuration
	const currentStepIndex = page - 1;
	const currentStep = welcomeFlow.steps[currentStepIndex];

	if (!currentStep) {
		return null;
	}

	const { component: StepComponent, props: stepProps } = currentStep({
		onClickNext: nextClickHandler,
		onClickPrevious: prevClickHandler
	});

	return (
		<Styled.Wrapper>
			<StepComponent {...stepProps} />
		</Styled.Wrapper>
	);
};

export default Welcome;
